export class NotificationEnvironment {
  public static getName = () => 'benzinga-notification';
  public static getEnvironment = (env: Record<string, string>) => ({
    rootUrl: new URL(env.rootUrl ?? 'https://www.benzinga.com/'),
    socketUrl: new URL(env.socketUrl ?? 'wss://api.benzinga.com/api/v1.1/notification/ws'),
    url: new URL(env.url ?? 'https://api.benzinga.com/'),
    vapidPublicKey:
      env.vapidPublicKey ?? 'BDN_oYoaPKcRPMSCMHGxwlWX34meNEy7OrKVDpuMtbNlOOlR1kBfaddpmPwW3BPPWiLeJMVZoaTq7YbdKD2vTF0',
    webPushRoot: new URL(env.webPushRoot ?? 'https://www.benzinga.com/web-push'),
  });
}
